module.exports = __webpack_public_path__ + "img/Group 683.4816e8f0.png";